import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { Stream } from 'src/models/stream';
import { PlayerService } from 'src/app/services/player.service';
import { FormResponse } from 'src/models/form-response';
import { AccountService } from 'src/app/services/account.service';
import { User } from 'src/models/user';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-side',
  templateUrl: './side.component.html',
  styleUrls: ['./side.component.scss']
})
export class SideComponent implements OnInit {

  public favorites: Array<Stream>;

  constructor(
    private accountService: AccountService, 
    private userService: UserService, 
    private playerService: PlayerService, 
    private toastr: ToastrService,
    private router: Router) {
  }

  ngOnInit() {
    this.accountService.loggedInUser.subscribe((user: User) => {
        if (user !== undefined) {
          this.userService.getFavorites().subscribe((streams: Array<Stream>) => {
              this.favorites = streams;
          });
        } else {
          this.favorites = undefined;
        }
    });
  }

  public onPlayStreamClicked(stream: Stream) {
    if (isNaN(stream.id)) {
      this.router.navigate(['/podcast/' + stream.id]);
    } else {
      this.playerService.setCurrentStream(stream);
    }
  }

  public remove(stream: Stream) {

    if (this.accountService.loggedInUser.getValue() === undefined) {
      this.toastr.error('Du musst eingeloggt sein, um diese Aktion auszuführen.', 'Fehler');
    } else {
      const observable = this.userService.removeFromFavorites(stream);

      observable.subscribe((formResponse: FormResponse) => {
          if (formResponse.result) {
            this.toastr.success('Der Sender wurde entfernt.');
          } else {
            this.toastr.error('Es ist ein Fehler aufgetreten.', 'Fehler');
          }
        });
    }
  }
}
